<template>
  <div class="video-player-editor">
    <el-form ref="form" label-width="80px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="视频">
        <select-video v-model="currentItem.url"></select-video>
      </el-form-item>
      <el-form-item label="封面图片">
        <img class="video-thumb cursor-pointer" :src="currentItem.img_src" @click="selectThumb">
      </el-form-item>
    </el-form>
    <upload-img ref="upload"></upload-img>
  </div>
</template>
<script>
import UploadImg from '@/components/UploadImg'
import SelectVideo from '@/components/SelectVideo/SelectVideo'
export default {
  name: 'videoPlayEditor',
  components: {
    UploadImg,
    SelectVideo
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  methods: {
    selectThumb () {
      this.$refs.upload.show([this.currentItem.img_src], 'thumb', 1).then(res => {
        if (res.length) {
          this.currentItem.img_src = res[0]
        }
      }).catch(_ => {})
    }
  }
}
</script>
<style lang="less" scoped>
.video-thumb {
  height: 60px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/videoPlayerEditor.vue